import React from "react";

import styles from "./DetailsList.module.scss";
import DynamicFontAwesomeIcon from "components/elements/DynamicFontAwesomeIcon";

const DetailsList = (props) => {
	const { list, data } = props;

    let listToRender = data?.[0]?.list ?? list;
	return (
        <div className={`${styles.DetailsList}`}>
            <div className="d-flex align-items-center my-3">
                <h4 className="card-title mb-0">{listToRender?.title}</h4>
            </div>
            <ul className="list-group list-group-flush">
                {listToRender?.items && listToRender?.items.map((item, index) => (
                    (item.value) && (
                        <li key={index} className="list-group-item d-flex justify-content-between flex-nowrap">
                            <div className="d-flex me-3">
                                {item.icon && <DynamicFontAwesomeIcon iconName={item.icon} size="lg" className="list-icon text-center text-primary me-2" />}
                                {item.title && <span>{item.title}:</span>}
                            </div>
                            {item.value && <span className="text-end" dangerouslySetInnerHTML={{ __html: item.value}}></span>}
                        </li>
                    )
                ))}
            </ul>
        </div>
	);
};

export default DetailsList;
